export var Region;
(function (Region) {
    Region["US"] = "us";
    Region["EU"] = "eu";
    Region["AP"] = "ap";
})(Region || (Region = {}));
export var SupportedRegionCountryCode;
(function (SupportedRegionCountryCode) {
    SupportedRegionCountryCode["USA"] = "usa";
    SupportedRegionCountryCode["GBR"] = "gbr";
    SupportedRegionCountryCode["AUS"] = "aus";
    SupportedRegionCountryCode["IRL"] = "irl";
})(SupportedRegionCountryCode || (SupportedRegionCountryCode = {}));
